import React from 'react';
import { ArrowRight, CheckCircle2, Zap, Plus, Key, Globe } from 'lucide-react';
export function Hero() {
  return <section className="pt-32 pb-20 overflow-hidden" data-id="element-91">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-92">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-93">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-blue-50 text-blue-700 text-sm font-medium mb-6" data-id="element-94">
            <Zap className="w-4 h-4 fill-current" data-id="element-95" />
            <span data-id="element-96">Zero code LLM billing</span>
          </div>
          <h1 className="text-5xl md:text-6xl font-extrabold text-gray-900 tracking-tight mb-6 leading-[1.1]" data-id="element-97">
            Add usage-based AI billing to your product{' '}
            <span className="text-blue-600" data-id="element-98">in minutes</span>
          </h1>
          <p className="text-xl text-gray-600 mb-10 leading-relaxed" data-id="element-99">
            TokenGates is a low-latency, OpenAI-compatible LLM gateway that
            automatically tracks your users' AI usage and reports to your
            billing providers.
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4" data-id="element-100">
            <a href="https://us.posthog.com/external_surveys/019da0fa-860d-0000-f825-d448b1152f42" target="_blank" rel="noopener noreferrer" className="w-full sm:w-auto bg-blue-600 text-white px-8 py-4 rounded-xl text-lg font-bold hover:bg-blue-700 transition-all shadow-lg shadow-blue-200 flex items-center justify-center gap-2" data-id="element-101">
              Start Free <ArrowRight className="w-5 h-5" data-id="element-102" />
            </a>
            <a href="#problem-section" className="w-full sm:w-auto bg-white text-gray-700 border border-gray-200 px-8 py-4 rounded-xl text-lg font-bold hover:bg-gray-50 transition-all flex items-center justify-center" data-id="element-103">
              See How It Works
            </a>
          </div>
          <div className="mt-8 flex flex-wrap items-center justify-center gap-3" data-id="element-104">
            <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-gray-50 border border-gray-200 text-xs font-medium text-gray-600" data-id="element-105">
              <CheckCircle2 className="w-3.5 h-3.5 text-green-500" data-id="element-106" /> 5
              Continents
            </span>
            <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-gray-50 border border-gray-200 text-xs font-medium text-gray-600" data-id="element-107">
              <CheckCircle2 className="w-3.5 h-3.5 text-green-500" data-id="element-108" /> 26 PoP
              locations
            </span>
            <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-gray-50 border border-gray-200 text-xs font-medium text-gray-600" data-id="element-109">
              <CheckCircle2 className="w-3.5 h-3.5 text-green-500" data-id="element-110" /> Scales
              Automatically
            </span>
          </div>
        </div>

        {/* 3-Step Visual */}
        <div className="relative mt-12 grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-111">
          {/* Step 1 */}
          <div className="bg-white p-8 rounded-2xl border border-gray-100 shadow-xl shadow-gray-100/50 flex flex-col h-full" data-id="element-112">
            <div className="flex items-center gap-3 mb-6" data-id="element-113">
              <div className="w-10 h-10 rounded-lg bg-blue-600 flex items-center justify-center text-white" data-id="element-114">
                <Plus className="w-5 h-5" data-id="element-115" />
              </div>
              <h3 className="text-lg font-bold text-gray-900" data-id="element-116">
                1. Create Project
              </h3>
            </div>
            <div className="bg-gray-50 rounded-xl p-6 border border-gray-100 flex-grow" data-id="element-117">
              <p className="text-sm text-gray-500 mb-4 font-medium" data-id="element-118">
                Name your project
              </p>
              <div className="bg-white border border-gray-200 rounded-lg px-4 py-2 text-sm text-gray-400 mb-4" data-id="element-119">
                My AI App
              </div>
              <button className="w-full bg-blue-600 text-white py-2 rounded-lg text-sm font-bold opacity-50 cursor-not-allowed" data-id="element-120">
                Create Project
              </button>
            </div>
          </div>

          {/* Step 2 */}
          <div className="bg-white p-8 rounded-2xl border border-gray-100 shadow-xl shadow-gray-100/50 flex flex-col h-full" data-id="element-121">
            <div className="flex items-center gap-3 mb-6" data-id="element-122">
              <div className="w-10 h-10 rounded-lg bg-blue-600 flex items-center justify-center text-white" data-id="element-123">
                <Key className="w-5 h-5" data-id="element-124" />
              </div>
              <h3 className="text-lg font-bold text-gray-900" data-id="element-125">
                2. Add Your Keys
              </h3>
            </div>
            <div className="space-y-6 flex-grow" data-id="element-126">
              <div data-id="element-127">
                <p className="text-[10px] font-bold text-gray-400 uppercase tracking-widest mb-3" data-id="element-128">
                  Auth Provider
                </p>
                <div className="flex flex-wrap gap-2" data-id="element-129">
                  <span className="px-3 py-1.5 bg-gray-50 border border-gray-100 rounded-full text-xs font-semibold text-gray-700" data-id="element-130">
                    Clerk
                  </span>
                  <span className="px-3 py-1.5 bg-gray-50 border border-gray-100 rounded-full text-xs font-semibold text-gray-700" data-id="element-131">
                    PropelAuth
                  </span>
                </div>
              </div>
              <div data-id="element-132">
                <p className="text-[10px] font-bold text-gray-400 uppercase tracking-widest mb-3" data-id="element-133">
                  LLM Provider
                </p>
                <div className="flex flex-wrap gap-2" data-id="element-134">
                  <span className="px-3 py-1.5 bg-gray-50 border border-gray-100 rounded-full text-xs font-semibold text-gray-700" data-id="element-135">
                    OpenAI
                  </span>
                  <span className="px-3 py-1.5 bg-gray-50 border border-gray-100 rounded-full text-xs font-semibold text-gray-700" data-id="element-136">
                    Anthropic
                  </span>
                  <span className="px-3 py-1.5 bg-gray-50 border border-gray-100 rounded-full text-xs font-semibold text-gray-700" data-id="element-137">
                    Groq
                  </span>
                  <span className="px-3 py-1.5 bg-gray-50 border border-gray-100 rounded-full text-xs font-semibold text-gray-700" data-id="element-138">
                    Fireworks
                  </span>
                  <span className="px-3 py-1.5 bg-gray-50 border border-gray-100 rounded-full text-xs font-semibold text-gray-700" data-id="element-139">
                    Gemini
                  </span>
                  <span className="px-3 py-1.5 bg-blue-50 border border-blue-100 rounded-full text-xs font-bold text-blue-600" data-id="element-140">
                    + 9 more
                  </span>
                </div>
              </div>
              <div data-id="element-141">
                <p className="text-[10px] font-bold text-gray-400 uppercase tracking-widest mb-3" data-id="element-142">
                  Billing Provider
                </p>
                <div className="flex flex-wrap gap-2" data-id="element-143">
                  <span className="px-3 py-1.5 bg-gray-50 border border-gray-100 rounded-full text-xs font-semibold text-gray-700" data-id="element-144">
                    Stripe
                  </span>
                  <span className="px-3 py-1.5 bg-gray-50 border border-gray-100 rounded-full text-xs font-semibold text-gray-700" data-id="element-145">
                    Polar.sh
                  </span>
                </div>
              </div>
            </div>
          </div>

          {/* Step 3 */}
          <div className="bg-white p-8 rounded-2xl border border-gray-100 shadow-xl shadow-gray-100/50 flex flex-col h-full" data-id="element-146">
            <div className="flex items-center gap-3 mb-6" data-id="element-147">
              <div className="w-10 h-10 rounded-lg bg-blue-600 flex items-center justify-center text-white" data-id="element-148">
                <Globe className="w-5 h-5" data-id="element-149" />
              </div>
              <h3 className="text-lg font-bold text-gray-900" data-id="element-150">
                3. Get Endpoint
              </h3>
            </div>
            <div className="bg-blue-50 rounded-xl p-4 border border-blue-100 mb-4" data-id="element-151">
              <p className="text-xs font-bold text-blue-400 uppercase tracking-wider mb-2" data-id="element-152">
                Your API Endpoint
              </p>
              <code className="text-xs text-blue-700 font-mono break-all" data-id="element-153">
                https://api.tokengates.sh/v1/proj_123
              </code>
            </div>
            <div className="text-sm text-gray-600 leading-relaxed" data-id="element-154">
              Send requests from user devices using{' '}
              <span className="font-bold text-gray-900" data-id="element-155">JWTs</span> from your
              auth provider or use a{' '}
              <span className="font-bold text-gray-900" data-id="element-156">Master API Key</span>{' '}
              for backend requests.
            </div>
          </div>
        </div>
      </div>
    </section>;
}